export const THREE_ON_THREE_DIVISIONAL_TEAM_IDS = [87, 88, 89, 90];

export const allStarPlayerNameSort = [
    { id: 'lastName', desc: false },
    { id: 'firstName', desc: false },
];

const getNestedProps = (item, key) => {
    let value = item;
    key.split('.').forEach((key) => {
        value = value[key];
    });
    return value;
};

const getSortValue = (item1, item2, sorting) => {
    for (let i = 0; i < sorting.length; i++) {
        const { id, desc } = sorting[i];
        const value1 = getNestedProps(item1, id);
        const value2 = getNestedProps(item2, id);
        if (value1 === value2) {
            continue;
        }

        if (typeof value1 === 'string') {
            const sortValue = value1.localeCompare(value2);
            return desc ? sortValue * -1 : sortValue;
        }
        const sortValue = value1 > value2 ? 1 : -1;
        return desc ? sortValue * -1 : sortValue;
    }
    return 0;
};

export const sortAndRankData = (data, sort) => {
    data.sort((a, b) => getSortValue(a, b, sort)).map((d, index) => {
        d.rank = index + 1;
    });
    return data;
};
